// TopStats.tsx
import React from "react";

interface Stat {
  number: number;
  text: string;
  icon: React.ReactNode; 
  color?: string;        
}

interface TopStatsProps {
  stats: Stat[];
}

export default function TopStats({ stats }: TopStatsProps) {

  return (
    <div className="row g-4" style={{ marginBottom: "30px" }}>
      {stats.map((s, i) => {
        const formattedNumber = s.number;

        return (
          <div className="col-12 col-sm-6 col-xl-3" key={i}>
            <div
              className="card h-100 border-0"
              style={{ backgroundColor: s.color || "#005073", borderRadius: "12px" }}
            >
              <div
                className="card-body d-flex flex-column justify-content-between"
                style={{ padding: "16px 18px", minHeight: "140px" }}
              >
                <div style={{ marginBottom: "8px" }}>
                  {s.icon}
                </div>
                <h5
                  className="fw-bold mb-0"
                  style={{ fontSize: "34px", lineHeight: "36px", color: "#FFFFFF", fontWeight: 700 }}
                >
                  {formattedNumber}
                </h5>
                <p
                  className="mb-0"
                  style={{ fontSize: "14px", fontWeight: 500, color: "#FFFFFF", lineHeight: "18px" }}
                >
                  {s.text}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
